type ShareEntity = "news" | "jobs" | "learning";
type ShareUrlOptions = {
  includeCacheBuster?: boolean;
};

const configuredShareBase = String(import.meta.env.VITE_SHARE_BASE_URL || "")
  .trim()
  .replace(/\/+$/, "");

const toAbsoluteUrl = (value: string) => {
  if (typeof window === "undefined") {
    return value;
  }

  try {
    return new URL(value, window.location.origin).href;
  } catch {
    return value;
  }
};

export const buildShareUrl = (
  entity: ShareEntity,
  id: string,
  options: ShareUrlOptions = {}
) => {
  const includeCacheBuster = options.includeCacheBuster ?? true;
  const safeEntity = String(entity || "").trim().toLowerCase();
  const safeId = encodeURIComponent(String(id || "").trim());
  const sharePathBase = `/share/${safeEntity}/${safeId}`;
  const sharePath = includeCacheBuster
    ? `${sharePathBase}?v=${Date.now()}`
    : sharePathBase;

  if (configuredShareBase) {
    return `${configuredShareBase}${sharePath}`;
  }

  return toAbsoluteUrl(sharePath);
};
